export const DATETIME_FORMAT_FOR_DATETIME_PICKERS = 'MM/DD/YYYY hh:mm A';
